var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("\n      Pulling data from "),_c('a',{attrs:{"href":"https://github.com/HackerNews/API"}},[_c('strong',[_vm._v("HackerNews/API")])]),_vm._v(".\n    ")])])])
}]

export { render, staticRenderFns }